import { Blocks, Smartphone, UsersRound } from "lucide-react";
import {
  API_PORTAL_URL,
  WONYAPAY_APP_DOWNLOAD_PATH,
} from "./links";

export const wonyaOffers = [
  {
    id: "api-wonyapay",
    icon: Blocks,
    label: "Pour les développeurs",
    title: "Projet Développeur | API WonyaPay",
    description:
      "Une seule intégration pour connecter vos applications aux principaux réseaux Mobile Money en RDC.",
    benefits: [
      "Documentation claire et exemples d’intégration",
      "Suivi transactionnel et notifications de statut",
      "Authentification et échanges sécurisés",
    ],
    action: "Consulter la documentation",
    route: API_PORTAL_URL,
    external: true,
    pricingDetails: [
      { label: "Frais d’intégration", value: "50 USD" },
      { label: "Commission par transaction", value: "3 %" },
    ],
    featured: true,
  },
  {
    id: "appmobile",
    icon: Smartphone,
    label: "Pour les prestataires de services et les marchands",
    title: "Application mobile WonyaPay",
    description:
      "Encaissez, transférez et pilotez vos caisses en CDF ou USD depuis une expérience mobile simple.",
    benefits: [
      "Création et gestion de caisses",
      "Encaissement et confirmation instantanée",
      "Transfert vers les réseaux Mobile Money",
    ],
    action: "Découvrir l’application",
    route: WONYAPAY_APP_DOWNLOAD_PATH,
    pricing: "Accès gratuit",
  },
  {
    id: "bulkpay",
    icon: UsersRound,
    label: "Pour les opérations",
    title: "Paiement en Masse | BulkPay",
    description:
      "Préparez, contrôlez et exécutez vos paiements en masse depuis un parcours conçu pour les équipes métier.",
    benefits: [
      "Import et traitement de listes de paiements",
      "Validation des numéros et des montants",
      "Historique détaillé de chaque opération",
    ],
    action: "Découvrir BulkPay",
    disabled: true,
    pricing: "2 à 5 % par transaction selon le volume",
  },
];
